import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getData, postData } from "../../services/Axios/Axios";
import { ApiUrl } from "../../config/apiConfig";
import UseCommonService from "../../services/commonService/commonService"; 
import { useLoader } from "../../components/loader/loader";
import "../../assets/css/responsive.css";
import "../../assets/css/style.css";
import messageService from "../../services/message/messageService";
import { showAPiError_mesage } from "../../services/validationService/validationservice";
import iconeyes from "../../assets/img/eye.svg";
import eye_close_ic from "../../assets/img/eye_close_ic.svg";

interface  Error {
  email?: any,
  password?: any,
}


const Login = () => {
  const { show, hide } = useLoader(); 
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState<any>(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });


   const ForgetPassword= ()=>{
    navigate('/Forgotpassword')
   }

const openNewAccount = ()=>{
  navigate('/Newaccount')
}

let term = ()=>{
  navigate('/privacypolicy')

  
}

  const [errors, setErrors] = useState <Error>({}); 
  const [Rememberme ,setRememberme]=useState(false)
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log(event,"event>>>>>>>>.")
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value }); 
    setErrors({ ...errors, [name]: "" });
  };

  const handleRememberMeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRememberme(event.target.checked);
  };

  useEffect(()=>{

    const storedEmail = localStorage.getItem("email");
    const storedPassword = localStorage.getItem("password");

    if (storedEmail && storedPassword) {
      setFormData({...formData,email:storedEmail,password:storedPassword})
    }
  },[])
  const handleSubmit = async (event: any) => {
    console.log(event,"event")
    event.preventDefault();   
    let isValid = true;
    const errors: { [key: string]: string } = {};

    if (!formData.password) {
      errors.password = "Password is required";
      isValid = false;
    } 
    



    if (!formData.email) {
      errors.email = "Email is  required";
      isValid = false;
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(formData.email)
    ) {
      errors.email = "Invalid email address";
      isValid = false;
    }

    setErrors(errors);
    if (isValid) {
      try {
        const response = await postData(ApiUrl.login, formData,{ show, hide });
        console.log("Data posted successfully:", response);
        localStorageSetRole(response);
     
        const loggedInUserRes = await getData(ApiUrl.getAdminByEmail + formData.email);
        if (loggedInUserRes) {
          console.log("loggedInUserRes.data", loggedInUserRes.data)

          localStorage.setItem("userData", JSON.stringify(loggedInUserRes.data));

        }
        const messageServices = messageService();
        navigate('/dashboard')

        messageServices.toast(
          "success",
          messageServices.message.loginAgain
        );


      } catch (erre: any) {
        console.log(erre,"djksfkjbfks")
        const MessageStore = erre?.response?.data?.message;
        console.log(MessageStore,"MessageStoreMessageStore")
        showAPiError_mesage(MessageStore);
      }
    }
   
  };

  const localStorageSetRole = (data: any) => {
    const commonService = UseCommonService(); 
    commonService.setToken(data.accessToken);
    commonService.setLocalData('vendor_profile' ,data.data ,true);
  };


  const handleKeyPress = (e: any) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(e as any);
    }
  };

  return (
    <>

<section className="sec-i fixsec bg">
    
     
          <div className="main-position">
            <div className="main-right-box">
              <div className="login-form">
                <div className="login-title-box">
                  <h2 className="login-title center">TMS Admin</h2>
                  <p className="login-sm-title hide">Enter the details to continue.</p>
                </div>
                <form  className="formcontrol">
                  <input type="email" placeholder="Email" className="inputcontrol" id="email"
                 name="email" required  value={formData.email}  onChange={handleChange}/>
                  {errors.email && <div className="error">{errors.email}</div>}

                  <div className="flexbox-btwn">
                    {/* <label className="password-inline">
                      <input type="password" placeholder="Password" className="inputcontrol" id="password"
                     name="password" required  value={formData.password} onChange={handleChange}/>
                      <img src={require("../../assets/img/eye.svg")} className="eye-ic" alt="" />
                    </label>
                     {errors.password && <div className="error">{errors.password}</div>} */}

<label className="password-inline">
                        <input
                          type={showPassword ? "text" : "password"}
                          placeholder="Password"
                          className="inputcontrol"
                          id="password"
                          name="password"
                          required
                          value={formData.password}
                          onChange={handleChange}
                          onKeyPress={handleKeyPress}
                        />
                        <img
                          src={showPassword ? eye_close_ic : iconeyes}
                          className="eye-ic"
                          onClick={() => setShowPassword(!showPassword)}
                          alt=""
                        />
                      </label>
                      {errors.password && (
                        <div className="error">{errors.password}</div>
                      )}
                  </div>
                  <div className="login-btn-box">
                    <a className="login-btn" type="submit" onClick={handleSubmit}>Login</a>
                  </div>
                </form>
              </div>
            </div>
         
          </div>
      
    </section>





    </>
  
  );
};

export default Login; 
